/**
 * Client-side permission helper
 */

export function hasPermission(user, permission) {
  if (!user) return false;
  const role = String(user.role || '').toUpperCase();
  if (role === 'SUPERADMIN') return true;
  if (!permission) return true;

  const permissions = Array.isArray(user.permissions) ? user.permissions : [];
  return permissions.includes(permission);
}

export function hasAnyPermission(user, permissions = []) {
  if (!user) return false;
  const role = String(user.role || '').toUpperCase();
  if (role === 'SUPERADMIN') return true;
  if (!permissions || permissions.length === 0) return true;

  const userPerms = Array.isArray(user.permissions) ? user.permissions : [];
  return permissions.some((p) => userPerms.includes(p));
}
